module.exports = __webpack_public_path__ + "media/MUSIC.ce9518b4.mp3";